import { type ProCon } from "@portal/api/decisioning";
import { Disclosure } from "../../../patterns/disclosure";
import { Text } from "../../../primitives";

export type SnapshotProCon = Pick<ProCon, "kind"> & { factor: Pick<ProCon["factor"], "name"> };

export const ProConSnapshotRow = ({
	proCon,
	testId,
}: {
	proCon: SnapshotProCon;
	testId?: string;
}) => (
	<Disclosure.Row data-testid={testId}>
		<Text type="caption" color={proCon.kind === "pro" ? "confirm" : "danger"}>
			{proCon.kind === "pro" ? "Pro" : "Con"}
		</Text>
		<Text type="caption" color="primary" className="min-w-0">
			{proCon.factor.name}
		</Text>
	</Disclosure.Row>
);
